import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';
import { RequestsInstance } from './index';

type GiifTypesResponse = {
	giifTypes: Record<string, string>;
};

export const GiifTypesApiWrapper = (requests: RequestsInstance) => {
	return {
		getGiifTypes: () => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get<GiifTypesResponse>(`/misc/giif-types`, config);
		},
	};
};
